type TData = Record<string, any>;

export function transformIntlMessages(data: TData) {
  return Object.entries(data).reduce<TData>((intlMessages, currentData) => {
    const [topic, messages] = currentData;

    const langs = Object.keys(messages);

    for (const lang of langs) {
      intlMessages = {
        ...intlMessages,
        [lang]: {
          ...intlMessages[lang],
          [topic]: messages[lang]
        }
      };
    }

    return intlMessages;
  }, {});
}
